module.exports = __webpack_public_path__ + "static/media/pedestrian.2d86d284.svg";